import * as React from 'react';
import { StatusBarContainer } from './status-bar-components';

type Props = {
  variant?: 'primary' | 'secondary' | 'magento' | 'success';
  children: any;
};

export default function StatusBar({ variant = 'primary', children }: Props) {
  return <StatusBarContainer variant={variant}>{children}</StatusBarContainer>;
}
